<template>
  <section v-if="highlights && highlights.length" class="py-24 relative">
    <h2 class="mb-16 heading-4-bd">Highlights of this Trip</h2>
    <template v-if="onlyText">
      <div v-for="(item, key) in highlights" :key="key" class="flex mb-16">
        <DJIcon :size="20" color="#197660" class="mt-4">
          <IconStarDuotone />
        </DJIcon>
        <span class="ml-12 text-md-rg gray-950 maxw-685">{{ item }}</span>
      </div>
    </template>
    <template v-else>
      <div class="wrapper-slide">
        <transition>
          <Carousel :wrap-around="false" :itemsToShow="itemsToShow" class="inner-wrapper">
            <template #counter> </template>
            <Slide class="carousel__item pr-16" v-for="(item, index) in highlights" :key="index">
              <div class="relative h-380">
                <img class="img-cover overflow-hidden br-16 db" :src="`${$assetsCdn}/images/aboutus/${item.img}`" alt="avatar" />
                <div class="tl absolute pa-12 pt-8 wp-100 bottom-0 left-0 h-86 bg-brand-800 white br-b-16 truncate">
                  <span class="text-md-sb">{{ item.author }}</span>
                </div>
              </div>
            </Slide>
            <template #addons>
              <Navigation>
                <template #prev>
                  <div class="pa-8 pb-6 br-999 bd-1 bd-gray-300-new">
                    <DJIcon :size="20">
                      <IconCaretLeft />
                    </DJIcon>
                  </div>
                </template>
                <template #next>
                  <div class="pa-8 pb-6 br-999 bd-1 bd-gray-300-new">
                    <DJIcon :size="20">
                      <IconCaretRight />
                    </DJIcon>
                  </div>
                </template>
              </Navigation>
            </template>
          </Carousel>
        </transition>
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue"
import DJIcon from '~/components/ui/icon/Icon.vue'
import { IconStarDuotone, IconCaretLeft, IconCaretRight } from '~/components/ui/icon/icons'
import Slide from '~/components/ui/carousel/Slide.vue'
import Carousel from '~/components/ui/carousel/Carousel.vue'
import Navigation from '~/components/ui/carousel/Navigation.vue'

interface Props {
  highlights: Array<string> | null
}
withDefaults(defineProps<Props>(), {
  highlights: () => [],
})

const { isMobile } = useDevice()

const onlyText = computed(() => true)

const itemsToShow = computed(() => {
  return isMobile ? 1.6 : 2.6
})
</script>

<style scoped lang="scss">
.wrapper-slide {
  width: 100%;
  @include phone {
    width: 100%;
  }
  :deep(.carousel) {
    .carousel__prev {
      position: absolute;
      top: -58px;
      left: unset;
      right: 40px;
      transform: none;
      @include phone {
        top: -50px;
        left: unset;
        right: 40px;
      }
    }
    .carousel__next {
      position: absolute;
      top: -58px;
      right: 0;
      left: unset;
      transform: none;
      @include phone {
        top: -50px;
        right: 0;
        left: unset;
      }
    }
  }
}
.carousel__slide {
  opacity: 1;
}
</style>
